import React from "react";

import Button from "components/ui/button/Button";

type ActionMessageObjectType = "list" | "bid" | "lead";

type ActionButtonProps = {
  objectType: ActionMessageObjectType;
  url: string;
};

export function ToastAction({ objectType, url }: ActionButtonProps) {
  return (
    <Button as="a" href={url} target="_blank">
      View {objectType}
    </Button>
  );
}
